import { render, staticRenderFns } from "./CustomerInformationConfigurator.vue?vue&type=template&id=cf0dabe6"
import script from "./CustomerInformationConfigurator.vue?vue&type=script&lang=js"
export * from "./CustomerInformationConfigurator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports